module.exports = __webpack_public_path__ + "img/sy.d3878311.png";